import useSWR, { SWRResponse } from 'swr';

import { Project } from 'models';

import { ProjectService } from 'services/ProjectService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

type UseProject = (
    useProjectArguments?:
        | null
        | Project['id']
        | {
              id: Project['id'];
          },
    options?: { depth?: number },
) => SWRResponse & {
    project: Project | null;
};

const useProject: UseProject = (useProjectArguments, { depth = 0 } = {}) => {
    let projectId = '';

    if (useProjectArguments && typeof useProjectArguments === 'string') {
        projectId = useProjectArguments;
    }

    if (useProjectArguments && typeof useProjectArguments === 'object') {
        projectId = useProjectArguments.id;
    }

    const swr = useSWR(
        ...prepareConditionalSwrArgs({
            key: `/api/projects/${projectId}?depth=${depth}`,
            fetcher: () => ProjectService.get(projectId!, { depth }),
            condition: Boolean(projectId),
        }),
    );

    return {
        ...swr,
        project: swr.data as unknown as Project,
    };
};

export { useProject };
